import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import Layout from "../Layout";

function OrderFailed() {
  const { t } = useTranslation();



  return (
    <Layout title={t("order.failed.title")}>
      <section className="min-h-screen flex items-center justify-center px-4 py-12 md:py-16 bg-gradient-to-br from-destructive/5 via-background to-background relative overflow-hidden">
        {/* Background decorations */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-destructive/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-destructive/5 rounded-full blur-3xl"></div>

        <div className="container mx-auto max-w-2xl relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-card rounded-2xl border-2 border-border shadow-xl p-8 md:p-12 text-center"
          >
            {/* Failed Icon */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2, type: "spring" }}
              className="mb-6 flex justify-center"
            >
              <div className="relative">
                <div className="absolute inset-0 bg-destructive/20 rounded-full animate-ping"></div>
                <div className="relative bg-destructive/10 rounded-full p-6">
                  <XCircle className="w-20 h-20 md:w-24 md:h-24 text-destructive" />
                </div>
              </div>
            </motion.div>

            {/* Title */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4"
            >
              {t("order.failed.title")}
            </motion.h1>

            {/* Message */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-lg md:text-xl text-muted-foreground mb-8"
            >
              {t("order.failed.message")}
            </motion.p>




            {/* <Button
                onClick={() => navigate("/")}
                variant="outline"
                className="px-8 py-6 text-base md:text-lg font-semibold rounded-xl border-2 hover:bg-muted transition-all duration-300 flex items-center gap-2"
              >
                <Home className="w-5 h-5" />
                {t("order.failed.backToHome")}
              </Button> */}
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}

export default OrderFailed;
